import DelBox from '../comps/DelBox';
import AddWard from '../models/AddWard';
import { useEffect, useState, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';

const Wards = () => {
  const [formData, setFormData] = useState({
    l1: [],
    cat_type: 'ward',
    page_no: 0,
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
  });
  
  const [isAdmin, setIsAdmin] = useState(false);
  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [loading, setLoading] = useState(false);

  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    const userData = JSON.parse(sessionStorage.getItem("ldata"));
    const roleId = userData?.role_id;
    
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    
    if (storedData) {
      setLoading(true);
      const parsed = JSON.parse(storedData);
      const fd = new FormData();
      fd.append('cat_type', formData.cat_type + "");
      fd.append('page_no', formData.page_no + "");
      fd.append('search_key', formData.search_key + "");
      fd.append('par_by', 1 + "");
      
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        
        if (response.data.status) {
          var records = response.data.records;
          if (records != null && records != undefined) {
            setFormData(prev => ({
              ...prev,
              l1: records
            }));
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error('Failed to load wards');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const delItem = async (editItem) => {
    if (!window.confirm('Are you sure you want to delete this ward?')) {
      return;
    }
    
    const fd = new FormData();
    fd.append('cat_id', editItem.cat_id + "");
    
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.delCatUrl, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      if (response.data.status) {
        initData();
        toast.success('Deleted Successfully');
      } else {
        toast.error('Failed to delete ward');
      }
    } catch (error) {
      console.error('Delete error:', error);
      toast.error('Failed to delete ward');
    }
  };

  const handleAddDepart = () => {
    formData.page_no = 0;
    initData();
  };

  useEffect(() => {
    console.log('Component mounted');
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      initData();
    }

    return () => {
      console.log('Component unmounted');
    };
  }, []);

  // ✅ Filter data based on search
  const filteredList = useMemo(() => {
    if (formData.search_key.trim() === "") {
      return formData.l1;
    }
    return formData.l1.filter(item =>
      item.cat_name?.toLowerCase().includes(formData.search_key.toLowerCase())
    );
  }, [formData.l1, formData.search_key]);

  // ✅ Define DataTable columns
  const columns = [
    {
      name: 'SN',
      selector: (row, index) => index + 1,
      sortable: false,
      width: '80px',
      center: true,
    },
    {
      name: 'Ward Name',
      selector: row => row.cat_name,
      sortable: true,
      grow: 2,
      cell: row => <strong>{row.cat_name}</strong>,
    },
    {
      name: 'Description',
      selector: row => row.cat_type1,
      sortable: true,
      grow: 2,
      cell: row => <span className="text-muted">{row.cat_type1 || 'N/A'}</span>,
    },
    {
      name: 'Action',
      center: true,
      width: '200px',
      cell: row => (
        <div className="d-flex gap-2">
          {/* EDIT BUTTON */}
          <button
            type="button"
            className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
            disabled={!isAdmin}
            style={{ opacity: !isAdmin ? 0.5 : 1 }}
            onClick={(e) => {
              e.preventDefault();
              setEditItem(row);
              document.getElementById("addbt453").click();
            }}
            title="Edit Ward"
          >
            <i className="ri-pencil-fill fs-16 me-1"></i> Edit
          </button>

          {/* DELETE BUTTON */}
          <button
            type="button"
            className="btn btn-sm btn-outline-danger d-inline-flex align-items-center"
            disabled={!isAdmin}
            style={{ opacity: !isAdmin ? 0.5 : 1 }}
            onClick={(e) => {
              e.preventDefault();
              delItem(row);
            }}
            title="Delete Ward"
          >
            <i className="ri-delete-bin-5-fill fs-16 me-1"></i> Delete
          </button>
        </div>
      ),
    },
  ];

  // ✅ Custom styles for DataTable
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#f3f6f9',
        borderBottom: '2px solid #e9ecef',
        minHeight: '48px',
      },
    },
    headCells: {
      style: {
        fontSize: '13px',
        fontWeight: '600',
        textTransform: 'uppercase',
        color: '#878a99',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
    },
    rows: {
      style: {
        minHeight: '56px',
        '&:hover': {
          backgroundColor: '#f8f9fa',
        },
      },
    },
    cells: {
      style: {
        paddingLeft: '16px',
        paddingRight: '16px',
        fontSize: '14px',
      },
    },
  };

  // ✅ Pagination options
  const paginationComponentOptions = {
    rowsPerPageText: 'Rows per page:',
    rangeSeparatorText: 'of',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All',
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              {/* HEADER */}
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Wards</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button 
                        id="addbt453" 
                        style={{ display: "none" }} 
                        type="button" 
                        className="btn btn-success add-btn" 
                        data-bs-toggle="modal" 
                        data-bs-target="#showModal"
                      >
                      </button>
                      <button 
                        type="button" 
                        className="btn btn-success add-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setEditItem(null);
                          document.getElementById("addbt453").click();
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add Ward
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* SEARCH BOX */}
              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-xxl-5 col-sm-6">
                      <div className="search-box">
                        <input 
                          className="form-control search" 
                          name="search_key" 
                          onChange={handleChange} 
                          value={formData.search_key} 
                          placeholder="Search by ward name..." 
                          type="text"
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {/* DATA TABLE */}
              <div className="card-body pt-0">
                <DataTable
                  columns={columns}
                  data={filteredList}
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
                  paginationComponentOptions={paginationComponentOptions}
                  highlightOnHover
                  striped
                  responsive
                  customStyles={customStyles}
                  progressPending={loading}
                  progressComponent={
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  }
                  noDataComponent={
                    <div className="text-center py-5">
                      <i className="ri-folder-open-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                      <h5 className="mt-3">No Wards Found</h5>
                      <p className="text-muted">No wards have been added yet. Click "Add Ward" to create one.</p>
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        </div>

        {/* MODALS */}
        <AddWard item={editItem} onAddDepart={handleAddDepart} />
        <DelBox />
      </div>
    </div>
  );
};

export default Wards;